/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_TelephoneInputs */

const en_wallet_card_telephone = /** @type {(inputs: Wallet_Card_TelephoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telephone`)
};

const fr_wallet_card_telephone = /** @type {(inputs: Wallet_Card_TelephoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléphone`)
};

/**
* | output |
* | --- |
* | "Telephone" |
*
* @param {Wallet_Card_TelephoneInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_telephone = /** @type {((inputs?: Wallet_Card_TelephoneInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_TelephoneInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_telephone(inputs)
	return fr_wallet_card_telephone(inputs)
});